import React, { useState,useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { registrarTap } from "../api";

const GaleriaHorizontal = ({ historias = [] , mostrarEmergencias = false}) => {
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
  const [indiceActual, setIndiceActual] = useState(null);
  const [comercioInfo, setComercioInfo] = useState({ logo: "", nombre: "" });
  const [cargadas, setCargadas] = useState({});
  const [logosCargados, setLogosCargados] = useState({});
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const isAndroid = /Android/.test(navigator.userAgent);

  const abrirVisor = (item, index) => {
    setImagenSeleccionada(item.contenido);
    setIndiceActual(index);
    setComercioInfo({
      logo: item.logo,
      nombre: item.nombre,
      id_sucursal: item.id_sucursal
    });
  };

  const manejarCarga = (index) => {
    setCargadas((prev) => ({ ...prev, [index]: true }));
  };

  const manejarCargaLogo = (index) => {
    setLogosCargados((prev) => ({ ...prev, [index]: true }));
  };

  const cambiarHistoria = (direccion) => {
    let nuevoIndice = indiceActual + direccion;
    if (nuevoIndice >= 0 && nuevoIndice < historias.length) {
      setImagenSeleccionada(historias[nuevoIndice].contenido);
      setIndiceActual(nuevoIndice);
      setComercioInfo({
        logo: historias[nuevoIndice].logo,
        nombre: historias[nuevoIndice].nombre,
        id_sucursal: historias[nuevoIndice].id_sucursal
      });
    } else {
      setImagenSeleccionada(null);
    }
  };

  return (
    <div>
      <div className="galeria-scroll" ref={scrollRef}>
      {mostrarEmergencias && (
      <div
        className="contenedor-imagen no-after"
        onClick={() => navigate('/emergencias')}
      >
        <div className="emergencia-miniatura">
          <img src="/assets/images/emergencias.svg" alt="Emergencias" className="icono-emergencia"/>
          <div className="texto-emergencia">EMERGENCIAS</div>
        </div>
      </div>
      )}
      {historias.map((item, index) => (
          <div
            className="contenedor-imagen"
            key={index}
            onClick={() => abrirVisor(item, index)}
          >
            {!cargadas[index] && <div className="skeleton skeleton-miniatura" />}
            <img
              src={item.contenido}
              alt={`historia-${index}`}
              className="miniatura"
              style={{ opacity: cargadas[index] ? 1 : 0 }}
              onLoad={() => manejarCarga(index)}
              onError={() => manejarCarga(index)}
            />
            {!logosCargados[index] && <div className="skeleton skeleton-logo"/>}
            <img
              src={item.logo}
              alt="logo"
              className="logo-superpuesto"
              style={{ opacity: logosCargados[index] ? 1 : 0 }}
              onLoad={() => manejarCargaLogo(index)}
              onError={() => manejarCargaLogo(index)}
            />
          </div>
        ))}
      </div>

      {imagenSeleccionada && (
        <div
          className="visor"
          onClick={(e) => {
            const ancho = e.currentTarget.offsetWidth;
            const clickX = e.nativeEvent.offsetX;
            if (clickX < ancho / 2) {
              cambiarHistoria(-1); // izquierda
            } else {
              cambiarHistoria(1); // derecha
            }
          }}
        >
          <div className="visor-overlay-top"></div>
          <div className={`visor-header ${isAndroid ? "android-padding" : ""}`}>
            <div className="visor-info">
              <img
                src={comercioInfo.logo}
                alt="logo"
                className="visor-logo"
                onClick={async (e) => {
                  e.stopPropagation();
                  const id_perfil = localStorage.getItem("id_perfil");
                  const id_sucursal = comercioInfo.id_sucursal;
                  if (!id_sucursal) return;
                  await registrarTap(id_sucursal, "historias", id_perfil);
                  navigate(`/comercio/app/${id_sucursal}`);
                }}
              />
              <span
                className="visor-nombre"
                onClick={async (e) => {
                  e.stopPropagation();
                  const id_perfil = localStorage.getItem("id_perfil");
                  const id_sucursal = comercioInfo.id_sucursal;
                  if (!id_sucursal) return;
                  await registrarTap(id_sucursal, "historias", id_perfil);
                  navigate(`/comercio/app/${id_sucursal}`);
                }}
              >
                {comercioInfo.nombre}
              </span>
            </div>
            <button
              className="boton-cerrar"
              onClick={(e) => {
                e.stopPropagation();
                setImagenSeleccionada(null);
                setIndiceActual(null);
              }}
            >
              ×
            </button>
          </div>
          <img
            src={imagenSeleccionada}
            alt="vista ampliada"
            className="visor-imagen"
          />
        </div>
      )}
    </div>
  );
};

export default GaleriaHorizontal;